/**
 * React Query stale times for friends/groups domain.
 * Keeps cache tuning in one place and aligned across hooks and prefetch.
 */

/** Groups list and group detail/dashboard – 2 minutes */
export const STALE_TIME_GROUPS_MS = 2 * 60 * 1000;

/** Friend stats (1v1 history) – 60 seconds */
export const STALE_TIME_FRIEND_STATS_MS = 60 * 1000;

/** Matches – 5 minutes */
export const STALE_TIME_MATCHES_MS = 5 * 60 * 1000;
